<div [class]="getClass()">
    <span *ngIf="(date && status)"> Hace {{getDateDiff(date)}}  días</span>
    <span *ngIf="!date && !status"> Sin evaluación</span>
</div>